module.exports = __webpack_public_path__ + "img/mobile-20.6735b27b.png";